const ROUTE_MAPPING: Record<string, string> = {
  'product-shelf': 'product-shelf',
  'model-portfolios': 'model-portfolio',
  clients: 'client',
  households: 'household',
  accounts: 'account',
  goals: 'goal',
  trading: 'trading',
  compliance: 'compliance',
  reports: 'report',
  fees: 'fee',
  'fee-grids': 'fee-grid',
  'billing-schedules': 'billing-schedule',
  'asset-classes': 'asset-classes',
  system: 'system',
  dashboard: 'dashboard',
  homepage: 'homepage',
};

const toKebabCase = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();

const stripPath = (path: string): string =>
  path.split('?')[0]?.replace(/\/+$/, '').replace(/^\/+/, '') ?? '';

export const resolveAnalyticsContext = (path: string): string => {
  const sanitizedPath = stripPath(path);
  if (!sanitizedPath) {
    return ROUTE_MAPPING.homepage;
  }

  const mainSegment = sanitizedPath.split('/').find(Boolean);
  if (!mainSegment) {
    return ROUTE_MAPPING.homepage;
  }

  const normalizedSegment = toKebabCase(mainSegment);
  return ROUTE_MAPPING[normalizedSegment] ?? normalizedSegment;
};

export { ROUTE_MAPPING };
